const VALID_CYCLES = ['monthly', 'annual', 'founder'] as const
type ValidCycle = typeof VALID_CYCLES[number]

function isValidCycle(value: unknown): value is ValidCycle {
  return typeof value === 'string' && (VALID_CYCLES as readonly string[]).includes(value)
}

export function consumePendingCheckout(): string | null {
  const raw = sessionStorage.getItem('pendingCheckout')
  if (!raw) return null
  sessionStorage.removeItem('pendingCheckout')
  try {
    const parsed = JSON.parse(raw)
    const planSlug = parsed?.plan_slug
    if (!planSlug || typeof planSlug !== 'string') return null
    const safeCycle: ValidCycle = isValidCycle(parsed?.cycle) ? parsed.cycle : 'monthly'
    const params = new URLSearchParams({ plan: planSlug, cycle: safeCycle })
    return `/checkout/v2?${params.toString()}`
  } catch {
    return null
  }
}
